import { useMutation } from '@apollo/client'
import { SoftwareManagementUpdateEmployeeDocument } from 'generated/resources/graphql'

interface QueryParameters {
  id: string
  phoneNumber: string
}

export const useUpdateEmployee = () => {
  const [updateEmployee, { loading }] = useMutation(SoftwareManagementUpdateEmployeeDocument)

  return {
    updateEmployee(params: QueryParameters) {
      return updateEmployee({ variables: { ...params } })
    },
    loading,
  }
}
